import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'monthName'
})
export class MonthNamePipe implements PipeTransform {
    transform(month: string, value: number): string {
        if (month) {
            let allMonth = month.split(' ');

            if (allMonth.length <= 1) {
                allMonth = month.split('|');
            }
            return allMonth[value - 1];
        }
        return '';
    }
}
